var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 342,
    height: 512,
    viewBox: "0 0 342 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M171 0C76.896 0 0.333008 76.563 0.333008 170.667C0.333008 198.917 7.39601 226.927 20.823 251.771L161.667 506.5C163.542 509.896 167.115 512 171 512C174.885 512 178.458 509.896 180.333 506.5L321.229 251.687C334.604 226.927 341.667 198.916 341.667 170.666C341.667 76.563 265.104 0 171 0ZM171 256C123.948 256 85.667 217.719 85.667 170.667C85.667 123.615 123.948 85.334 171 85.334C218.052 85.334 256.333 123.615 256.333 170.667C256.333 217.719 218.052 256 171 256Z",
    fill: "#00F260"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/pin.39bf7cb8335232f8cf994241ab0ba120.svg";
export { ForwardRef as ReactComponent };